<template>
	<div>
		<div class="foot-t" v-if="
        footer_hidden &&common_info.footer&&common_info.footer.footer_advert&&common_info.footer.footer_advert.list&&
        common_info.footer.footer_advert.list.length
      ">
			<div class="w">
				<ul class="foot-t-item">
					<template v-for="(item, index) in common_info.footer.footer_advert.list">
						<li v-if="item.url || item.main_title">
							<img class="img-default" :src="item.url" alt />
							<div class="foot_item_title">
								<span class="show-one-lines" v-text="item.main_title"></span>
								<p class="show-one-lines" v-if="item.other_title">{{ item.other_title }}</p>
							</div>
						</li>
					</template>
				</ul>
			</div>
		</div>
		<div class="foot-c" v-if="footer_hidden">
			<div class="w foot-c-item">
				<!-- 普伟龙祥 特有的 -->
				<!-- <div id="cnzz"></div> -->
				<ul v-for="(item, index) in common_info.help.list" :key="index">
					<li class="foot-title" v-text="item.title"></li>
					<li v-for="(value, key) in item.list" :key="key">
						<router-link :to="{ path: '/ttshop_details', query: { article_id: value.id } }"
							v-text="value.title"></router-link>
					</li>
				</ul>
				<ul>
					<li class="foot-title" v-if="common_info.gdjy.nickname" v-text="common_info.gdjy.nickname"></li>
					<li class="introduce" v-if="common_info.help.right_content.content"
						v-text="common_info.help.right_content.content"></li>
					<li class="introduce" v-if="common_info.gdjy.phone" v-text="common_info.gdjy.phone"></li>
					<!-- <li class="foot-tel" v-if="common_info.help.copyright.phone" v-text="'TEL：'+common_info.help.copyright.phone"></li> -->
				</ul>
			</div>
		</div>
		<div class="foot-b">
			<div class="w foot-b-item">
				<ul class="foot-bottom">
					<li class="public" v-if="common_info.help.copyright.network_card">
						<img src="../../assets/images/gongan.png" alt="" />
						<a :href="common_info.help.copyright.network_card_url" target="_blank"
							v-if="common_info.help.copyright.network_card_url">{{ common_info.help.copyright.network_card }}</a>
					</li>
					<li v-if="common_info.help.copyright.icp_url">
						<a :href="common_info.help.copyright.icp_url" target="_blank"
							v-text="common_info.help.copyright.icp_card" v-if="common_info.help.copyright.icp_url"></a>
						<span v-text="common_info.help.copyright.icp_card" v-else></span>
					</li>
					<template v-if="common_info.help.copyright.text">
						<li v-html="common_info.help.copyright.text"></li>
					</template>
					<!-- <li v-text="'Tel: '+common_info.help.copyright.phone"></li> -->
					<li v-if="common_info.help.copyright.statistics_url">
						<a :href="common_info.help.copyright.statistics_url" target="_blank">站长统计</a>
					</li>
					<!-- <li>
            <a href="https://www.oeob.net/" target="_blank">技术支持</a>
            <span>：</span>
            <a href="http://www.oeob.com/" target="_blank">天天向上</a>
          </li> -->
					<!-- <li>
						<a href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020181026110956000002915049-SAIC_SHOW_310000-2c9be8bd6f7928c3016fb396d8bc2209417&signData=MEUCIHekuTPuft+9PhsILMpNMyOOmt5EfJ9Alih1o6QjB68LAiEA1V6N1jDDkAcx9dUqUDnbRBMC9IyT+Vyw7KzCcV3mrZY=" target="_blank">
							<img class="img-default" src="../../assets/images/lz2.jpg" alt="" style="width: 14px;">
						</a>
					</li> -->
				</ul>

				<div class="foot-top">
					<template>
						<div v-for="(item, index) in common_info.help.links" :key="index" class="friendSingle">
							<a :href="item.link" target="_blank">
								<img v-if="item.type!=1&&item.url" :src="item.url" alt="" />
								<p v-if="item.type!=2&&item.name">{{ item.name }}</p>
							</a>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["footerhidden"],
		components: {},
		data() {
			return {
				footer_hidden: true,
			};
		},
		computed: {
			common_info() {
				let simulate = {
					footer: {
						footer_advert: {},
					},
					help: {
						links: {},
						list: {},
						right_content: {},
						copyright: {},
					},
					store: {
						electronic_license: '',
						electronic_url: ''
					},
					gdjy: {
						nickname: '',
					}
				};
				let commonData = this.$store.state.common_info || simulate;
				return commonData;
			},
		},
		created() {},
		mounted() {
			if (this.footerhidden != undefined) {
				this.footer_hidden = this.footerhidden;
			}
			// var cnzzs = "https:" == document.location.protocol ? "https://" : "http://";
			// document.getElementById("cnzz").innerHTML = unescape(
			//   "%3Cspan id='cnzz_stat_icon_1280737938'%3E%3C/span%3E%3Cscript src='" +
			//     cnzzs +
			//     "s9.cnzz.com/z_stat.php%3Fid%3D1280737938' type='text/javascript'%3E%3C/script%3E"
			// );
		},
		methods: {},
	};
</script>

<style lang="scss" scoped>
	.foot-t {
		width: 100%;
		background-color: #fafafa;

		.foot-t-item {
			height: 108px;
			display: flex;
			justify-content: space-between;
			border-bottom: solid 1px #f5f5f5;

			li {
				font-size: 20px;
				color: #333333;
				display: flex;
				align-items: center;

				img {
					display: block;
					// width: 37px;
					// height: 40px;
					width: 45px;
					height: 49px;
					margin-right: 15px;
				}

				span {
					font-size: 20px;
				}

				.foot_item_title {
					font-size: 14px;
					font-weight: 400;
					color: #999999;
					line-height: 20px;

					span {
						font-size: 20px;
						font-weight: 600;
						color: #333333;
						line-height: 28px;
						max-width: 200px;
					}

					p {
						font-size: 14px;
						margin-top: 2px;
						font-weight: 400;
						color: #999999;
						line-height: 20px;
						max-width: 200px;
					}
				}
			}
		}
	}

	.foot-c {
		width: 100%;
		border-top: 1px solid #ebebeb;
		background-color: #fafafa;
		padding: 40px 0;
		box-sizing: border-box;

		.foot-c-item {
			display: flex;
			justify-content: space-between;

			ul {
				color: #888888;

				li {
					margin-bottom: 6px;

					a {
						display: block;
						color: #888;
						line-height: 22px;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:hover {
							color: #ff0e25;
						}
					}
				}

				.introduce {
					width: 190px;
					line-height: 20px;
				}

				.foot-tel {
					color: #ff0e25;
					font-size: 16px;
					font-weight: bold;
				}
			}

			.foot-title {
				font-size: 14px;
				color: #666666;
				margin-bottom: 8px;
			}
		}
	}

	.foot-b {
		width: 100%;
		background-color: #fff;

		.foot-b-item {
			height: 78px;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;

			.foot-top {
				display: flex;
				flex-wrap: wrap;
				max-width: 900px;

				.friendSingle {
					margin-top: 10px;
				}

				div {
					display: flex;
					align-items: center;

					a {
						color: #888888;
					}

					.line {
						height: 10px;
						width: 1px;
						background-color: #b3b3b3;
						margin: 0 8px;
					}
				}

				div:nth-child(n+2) {
					margin-left: 10px;
				}

				div:last-child {
					.line {
						display: none;
					}
				}
			}

			.foot-bottom {
				display: flex;
				color: #bfbfbf;
				align-items: center;
				margin-top: 12px;
				justify-content: center;
				flex-wrap: wrap;
				width: 90%;

				li {
					margin-right: 16px;

					&:last-child {
						margin-right: 0;
					}

					position: relative;

					+li::before {
						content: "";
						width: 1px;
						height: 10px;
						background: #bfbfbf;
						position: absolute;
						top: 3px;
						left: -7px;
					}

					// &:last-child:before {
					//   display: none;
					// }
					span {
						cursor: pointer;
						transition: 0.5s;
						-moz-transition: 0.5s;
						-webkit-transition: 0.5s;
						-o-transition: 0.5s;

						&:hover {
							color: #ff0e25;
						}
					}
				}
			}
		}
	}

	.public {
		display: flex;
		align-items: center;

		img {
			width: 20px;
			height: 20px;
			margin-right: 5px;
		}
	}

	.friendSingle {
		flex-direction: column;
		justify-content: center;

		img {
			width: auto;
			height: 60px;
			object-fit: initial;
		}

		p {
			// color: #d5d5d5;
			color: #888888;
			// margin-top: 10px;
			text-align: center;
		}
	}
</style>